import React, { useEffect, useRef, useMemo } from 'react';
import { Box, Alert } from '@mui/material';
import LoadingIndicator from 'app/components/LoadingIndicator';
import { useSummarization } from 'app/context/SummarizationContext';
import { ExecutiveSummaryView } from './ExecutiveSummaryView';

const ExecutiveSummaryComponent = () => {
    const { init, loading, error, conversation_id, streamingText, isStreaming, resetState } = useSummarization();
    const hasInitializedRef = useRef(false);

    // Reset hasInitializedRef when conversation_id becomes null (after reset)
    useEffect(() => {
        if (!conversation_id && hasInitializedRef.current) {
            console.log('🔄 Conversation ID cleared, resetting initialization flag');
            hasInitializedRef.current = false;
        }
    }, [conversation_id]);

    // Initialize on mount - only once
    useEffect(() => {
        const initialize = async () => {
            if (!hasInitializedRef.current && !conversation_id && !loading) {
                hasInitializedRef.current = true;
                console.log('🔄 Initializing executive summary...');
                await init();
            }
        };

        initialize();
    }, [init, conversation_id, loading]);

    // Reset all states when component unmounts (page leaves)
    useEffect(() => {
        return () => {
            console.log('🔄 ExecutiveSummary unmounting - resetting all states');
            resetState();
        };
    }, [resetState]);

    // Memoize props to prevent unnecessary re-renders
    // Must be called before any early returns (React Hooks rule)
    const viewProps = useMemo(() => ({
        title: "Executive Summary",
        text: streamingText,
        isStreaming: isStreaming
    }), [streamingText, isStreaming]);

    // // Show loading state while initializing
    // if (loading || !conversation_id) {
    //     return (
    //         <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
    //             <LoadingIndicator />
    //         </Box>
    //     );
    // }

    // Show error state if initialization failed
    if (error) {
        return (
            <Box sx={{ p: 2 }}>
                <Alert severity="error">{error}</Alert>
            </Box>
        );
    }

    // Show ExecutiveSummaryView once initialized
    return (
            <ExecutiveSummaryView {...viewProps} />
    );
};

ExecutiveSummaryComponent.displayName = 'ExecutiveSummary';

export const ExecutiveSummary = React.memo(ExecutiveSummaryComponent);
